class ProductPopup {
  constructor(popup) {
    this.popup = popup;
    this.open = false;
    this.subscription = false;
    this.currentProduct = null;
    this.currentImageIndex = 0;
    this.galleryImages = [];

    this.closeBtn = this.popup.querySelector('.close');
    this.prevBtn = this.popup.querySelector('.slide-btn.prev');
    this.nextBtn = this.popup.querySelector('.slide-btn.next');
    this.loader = this.popup.querySelector('.loader');
    this.mediaImage = this.popup.querySelector('.product-popup__media-image');
    this.dots = this.popup.querySelector('.product-popup__dots');
    this.badge = this.popup.querySelector('.product-popup__badge');
    this.title = this.popup.querySelector('.product-title');
    this.subtitle = this.popup.querySelector('.product-popup__subtitle');
    this.stats = this.popup.querySelector('.product-popup__stats');
    this.pills = this.popup.querySelector('.product-popup__pills');
    this.ingredients = this.popup.querySelector('.product-popup__ingredients');
    this.recipe = this.popup.querySelector('.product-popup__recipe');
    this.allergens = this.popup.querySelector('.product-popup__allergens');
    this.nutritionGallery = this.popup.querySelector('.product-popup__nutrition-gallery');
    this.ctaButton = this.popup.querySelector('.product-popup__cta-button');
    this.quantity = this.popup.querySelector('quantity-input');
    this.quantityInput = this.popup.querySelector('.quantity__input');
    this.plusButton = this.popup.querySelector("button[name='plus']");
    this.addonCheckbox = this.popup.querySelector('addon-overlay input');

    this.closeBtn.addEventListener('click', () => this.closePopup());
    this.prevBtn.addEventListener('click', () => this.showPrevImage());
    this.nextBtn.addEventListener('click', () => this.showNextImage());
    this.ctaButton.addEventListener('click', () => this.addToCart());

    this.popup.addEventListener('click', (event) => {
      if (event.target.closest('.popup-content')) return;
      this.closePopup();
    });

    document.addEventListener('keyup', (event) => {
      if (!this.open) return;

      if (event.key === 'Escape') {
        this.closePopup();
      } else if (event.key === 'ArrowLeft') {
        this.showPrevImage();
      } else if (event.key === 'ArrowRight') {
        this.showNextImage();
      }
    });
  }

  openPopup(productHandle, subscription = false) {
    document.body.classList.add('lock-scroll');
    this.subscription = subscription;
    this.resetPopup();
    this.popup.style.display = 'grid';
    this.loader.style.display = 'grid';
    this.showProduct(productHandle);

    const smileUiEl = document.querySelector('#smile-ui-container');
    if (smileUiEl) smileUiEl.style.zIndex = 9999;
  }

  resetPopup() {
    this.currentProduct = null;
    this.currentImageIndex = 0;
    this.galleryImages = [];
    this.badge.hidden = true;
    this.badge.textContent = '';
    this.title.textContent = '';
    this.subtitle.textContent = '';
    this.stats.innerHTML = '';
    this.pills.innerHTML = '';
    this.ingredients.innerHTML = '';
    this.recipe.innerHTML = '';
    this.allergens.innerHTML = '';
    this.nutritionGallery.innerHTML = '';
    this.dots.innerHTML = '';
    /* srcset must be cleared too, or the next product briefly shows this one's image. */
    this.mediaImage.removeAttribute('srcset');
    this.mediaImage.removeAttribute('sizes');
    this.mediaImage.removeAttribute('src');
    this.mediaImage.alt = '';
    this.quantityInput.value = 0;
    this.quantityInput.dataset.id = '';
    this.quantityInput.dataset.price = '';
    this.quantity.dataset.id = '';
    this.ctaButton.textContent = 'add to cart';

    this.popup.querySelectorAll('.product-popup__accordion-item').forEach((item, index) => {
      item.open = index === 0;
    });

    if (this.popup.querySelector('addon-overlay')) {
      this.popup.querySelector('addon-overlay').style.display = 'none';
    }
  }

  async showProduct(productHandle) {
    const product = await this.getProduct(productHandle);
    this.currentProduct = product;
    this.open = true;
    this.loader.style.display = 'none';

    const variantId = product?.variants?.[0]?.id;
    if (variantId) {
      this.quantity.id = `QuantityInput-popup-${variantId}`;
      this.quantity.dataset.id = variantId;
      this.quantityInput.dataset.id = variantId;
      this.quantityInput.dataset.price = product.price;
      this.quantityInput.value = product.quantity || 0;
      this.setLockEvent(variantId);
    }

    this.renderAddon(product);
    this.renderProduct(product);
    this.applyOutOfStockState(product);

    if (window.ElevarDataLayer && window.__elevarBuildProduct && window.__elevarUserProps) {
      var recentlyFired = (window.ElevarDataLayer || []).some(function(entry) {
        return entry && entry.event === 'dl_view_item' &&
          entry.ecommerce && entry.ecommerce.detail &&
          entry.ecommerce.detail.products &&
          entry.ecommerce.detail.products[0] &&
          entry.ecommerce.detail.products[0].handle === productHandle;
      });

      if (!recentlyFired) {
        var v = product.variants && product.variants[0];
        var elevarProduct = window.__elevarBuildProduct({
          sku: (v && v.sku) || '',
          name: product.title || '',
          vendor: product.vendor || '',
          type: product.type || '',
          variant: (v && v.title) || '',
          price: ((v ? v.price : product.price) / 100).toFixed(2),
          product_id: String(product.id || ''),
          variant_id: String(v ? v.id : ''),
          compare_at_price: (((v && v.compare_at_price) || 0) / 100).toFixed(2),
          position: 1,
          image: product.featured_image || (product.images && product.images[0]) || '',
          url: window.location.origin + (product.url || ''),
          handle: product.handle || productHandle,
          list: window.location.pathname
        });

        window.ElevarDataLayer.push({
          event: 'dl_view_item',
          user_properties: window.__elevarUserProps,
          ecommerce: {
            currencyCode: window.__elevarCurrencyCode || 'CAD',
            detail: {
              actionField: { list: window.location.pathname, action: 'detail' },
              products: [elevarProduct]
            }
          }
        });
      }
    }
  }

  renderAddon(product) {
    const overlay = this.popup.querySelector('addon-overlay');
    if (!overlay) return;

    if (product.has_addon) {
      overlay.style.display = 'block';
      this.popup.querySelector('#addon_text').innerHTML = product.addon_text || '';
      this.addonCheckbox.checked = !!product.addon_checked;

      Object.keys(product.dataset || {}).forEach((attr) => {
        this.addonCheckbox.setAttribute(`data-${attr}`, product.dataset[attr]);
      });
    } else {
      overlay.style.display = 'none';
    }
  }

  renderProduct(product) {
    const subtitle = this.formatSubtitle(product.subtitle);
    const stats = this.getNutritionStats(product);
    const pills = this.getPills(product);

    this.title.textContent = product.title || '';
    this.subtitle.textContent = subtitle;
    this.subtitle.hidden = !subtitle;
    this.renderCtaButton(product);

    if (product.badgeLabel) {
      this.badge.hidden = false;
      this.badge.textContent = product.badgeLabel;
      this.badge.className = `product-popup__badge product-popup__badge--${this.handleize(product.badgeLabel)}`;
    } else {
      this.badge.hidden = true;
      this.badge.className = 'product-popup__badge';
    }

    this.stats.innerHTML = stats.map((stat) => `
      <div class="product-popup__stat">
        <span class="product-popup__stat-value">${stat.value}</span>
        <span class="product-popup__stat-label">${stat.label}</span>
      </div>
    `).join('');

    this.pills.innerHTML = pills.map((pill) => `
      <span class="product-popup__pill product-popup__pill--${pill.type}">
        <span class="product-popup__pill-icon" aria-hidden="true"></span>
        <span class="product-popup__pill-text">${pill.label}</span>
      </span>
    `).join('');

    this.renderAccordionContent(this.ingredients, product.keyIngredientsHtml, 'Ingredients coming soon.');
    this.renderAccordionContent(this.recipe, product.recipeDetailsHtml || product.description, 'Recipe details coming soon.');
    this.renderAccordionContent(this.allergens, product.allergensHtml, 'Allergen details coming soon.');
    this.renderNutritionGallery(product.info_images || []);

    this.galleryImages = this.buildGallery(product);
    this.renderGallery();
  }

  renderAccordionContent(target, html, fallbackText) {
    target.innerHTML = html && html.trim() ? html : `<p>${fallbackText}</p>`;
  }

  renderNutritionGallery(images) {
    if (!images.length) {
      this.nutritionGallery.innerHTML = '<p>Nutrition facts coming soon.</p>';
      return;
    }

    this.nutritionGallery.innerHTML = images.map((image) => `
      <img
        src="${this.webpImageUrl(image, 1200)}"
        srcset="${this.webpImageSrcset(image, [600, 900, 1200, 1600])}"
        sizes="(max-width: 749px) 100vw, 50vw"
        alt="Nutrition facts"
        loading="lazy"
      >
    `).join('');
  }

  renderCtaButton(product) {
    const variant = product.variants && product.variants[0];
    const price = Number(product.price || product.priceCents || variant?.price || 0);
    const compareAtPrice = Number(variant?.compare_at_price || product.compare_at_price || product.compareAtPriceCents || 0);
    const onSale = compareAtPrice > price;

    this.ctaButton.innerHTML = `
      <span class="product-popup__cta-label">add to cart</span>
      <span class="product-popup__cta-prices">
        ${onSale ? `<s class="product-popup__cta-price product-popup__cta-price--compare">${this.formatMoney(compareAtPrice)}</s>` : ''}
        <span class="product-popup__cta-price product-popup__cta-price--current">${this.formatMoney(price)}</span>
      </span>
    `;
  }

  /**
   * Popup images come from /products/{handle}.js, which returns the ORIGINAL uploads (often
   * full-resolution JPEG/PNG). They used to be dropped straight into `src`. Shopify's CDN
   * resizes and re-encodes from query params, so request WebP at a width that fits the slot.
   *
   * Only Shopify-hosted URLs are rewritten; anything else is returned untouched. Existing
   * width/format params (e.g. the card's data-gif, already rendered via image_url) are
   * overwritten rather than duplicated.
   */
  webpImageUrl(url, width) {
    if (!url || typeof url !== 'string') return url;
    if (url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return url;
    try {
      const absolute = url.startsWith('//') ? window.location.protocol + url : url;
      const parsed = new URL(absolute, window.location.origin);
      parsed.searchParams.set('width', String(width));
      parsed.searchParams.set('format', 'webp');
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  webpImageSrcset(url, widths) {
    return widths.map((width) => `${this.webpImageUrl(url, width)} ${width}w`).join(', ');
  }

  buildGallery(product) {
    const seen = new Set();
    const images = [];

    [product.gif || product.featured_image, ...(product.images || [])].forEach((image) => {
      if (!image || seen.has(image)) return;
      seen.add(image);
      images.push(image);
    });

    return images;
  }

  renderGallery() {
    if (!this.galleryImages.length) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
      return;
    }

    this.currentImageIndex = Math.min(this.currentImageIndex, this.galleryImages.length - 1);
    /* Media stage is at most 64rem square on desktop, 42vh wide up to 1100px, full width on
       phones (see the .product-popup__media-* rules in main-collection-product-grid.liquid).
       srcset/sizes are set before src so the browser picks from the list, not the fallback. */
    const galleryImage = this.galleryImages[this.currentImageIndex];
    this.mediaImage.sizes = '(max-width: 749px) 100vw, (max-width: 1100px) 42vh, 1024px';
    this.mediaImage.srcset = this.webpImageSrcset(galleryImage, [600, 900, 1200, 1600]);
    this.mediaImage.src = this.webpImageUrl(galleryImage, 1200);
    this.mediaImage.alt = this.currentProduct?.title || 'Product image';

    this.prevBtn.style.display = this.galleryImages.length > 1 ? 'grid' : 'none';
    this.nextBtn.style.display = this.galleryImages.length > 1 ? 'grid' : 'none';

    this.dots.innerHTML = this.galleryImages.map((_, index) => `
      <button
        type="button"
        class="product-popup__dot${index === this.currentImageIndex ? ' is-active' : ''}"
        aria-label="Show image ${index + 1}"
        data-index="${index}"
      ></button>
    `).join('');

    this.dots.querySelectorAll('.product-popup__dot').forEach((dot) => {
      dot.addEventListener('click', () => {
        this.currentImageIndex = Number(dot.dataset.index);
        this.renderGallery();
      });
    });
  }

  showNextImage() {
    if (this.galleryImages.length <= 1) return;
    this.currentImageIndex = (this.currentImageIndex + 1) % this.galleryImages.length;
    this.renderGallery();
  }

  showPrevImage() {
    if (this.galleryImages.length <= 1) return;
    this.currentImageIndex = (this.currentImageIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    this.renderGallery();
  }

  addToCart() {
    // Out of stock for this region - the CTA is disabled in applyOutOfStockState,
    // but guard here too so no other caller can reach the add path.
    if (this.currentProduct?.isOutOfStock) return;
    if (!this.plusButton) return;
    this.plusButton.click();
  }

  /**
   * Reflects the per-region out-of-stock flag from the card's modal data.
   * Removes the quantity stepper from the flow entirely rather than disabling
   * it, matching how the card itself handles the same state.
   */
  applyOutOfStockState(product) {
    const isOut = Boolean(product?.isOutOfStock);
    this.popup.classList.toggle('product-popup--oos', isOut);

    if (this.quantity) {
      this.quantity.style.display = isOut ? 'none' : '';
    }

    if (this.ctaButton) {
      this.ctaButton.disabled = isOut;
      this.ctaButton.setAttribute('aria-disabled', String(isOut));

      if (isOut) {
        if (this.ctaButtonDefaultText === undefined) {
          this.ctaButtonDefaultText = this.ctaButton.textContent;
        }
        this.ctaButton.textContent = product.outOfStockLabel || 'Out of stock';
      } else if (this.ctaButtonDefaultText !== undefined) {
        this.ctaButton.textContent = this.ctaButtonDefaultText;
      }
    }

    let notice = this.popup.querySelector('.product-popup__oos-notice');
    if (isOut) {
      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'product-popup__oos-notice';
        this.ctaButton?.parentNode?.insertBefore(notice, this.ctaButton);
      }
      notice.textContent = product.outOfStockMessage || '';
      notice.hidden = !notice.textContent;
    } else if (notice) {
      notice.hidden = true;
    }
  }

  setLockEvent(variantIdValue) {
    const variantId = String(variantIdValue);

    this.quantity.querySelectorAll('button').forEach((button) => {
      button.addEventListener('lockQuantity', (event) => {
        if (event.detail?.variantId !== variantId) return;
        button.disabled = true;
        button.style.cursor = 'default';
      });

      button.addEventListener('unlockQuantity', (event) => {
        if (event.detail?.variantId !== variantId) return;
        button.disabled = false;
        button.style.cursor = 'initial';
      });
    });

    this.quantityInput.addEventListener('lockQuantity', (event) => {
      if (event.detail?.variantId !== variantId) return;
      this.quantityInput.disabled = true;
      this.quantityInput.style.cursor = 'default';
    });

    this.quantityInput.addEventListener('unlockQuantity', (event) => {
      if (event.detail?.variantId !== variantId) return;
      this.quantityInput.disabled = false;
      this.quantityInput.style.cursor = 'initial';
    });
  }

  closePopup() {
    document.body.classList.remove('lock-scroll');
    this.popup.style.display = 'none';
    this.open = false;
    this.resetPopup();
  }

  async getProduct(productHandle) {
    const localData = this.getLocalProductData(productHandle);
    const product = await fetch(`/products/${productHandle}.js`)
      .then((response) => response.json());

    product.info_images = (product.images || []).filter((image) => image !== product.featured_image);

    const inputCandidates = Array.from(document.querySelectorAll(`input[data-id='${product.variants[0].id}']`));
    let productQuantity = inputCandidates.find((input) => !input.closest('.product-popup')) || inputCandidates[0];

    if (productQuantity?.dataset?.gif) {
      product.gif = productQuantity.dataset.gif.trim();
    }

    const quantityValue = productQuantity ? Number(productQuantity.value) : 0;
    const addonInputs = Array.from(document.querySelectorAll(`addon-overlay input[data-id='${product.variants[0].id}']`));
    const addonInput = addonInputs.find((input) => !input.closest('.product-popup')) || addonInputs[0];
    const addonTexts = Array.from(document.querySelectorAll(`addon-overlay #addon-span-${product.variants[0].id}`));
    const addonText = addonTexts.find((item) => !item.closest('.product-popup')) || addonTexts[0];

    if (addonInput) {
      product.has_addon = true;
      product.addon_checked = addonInput.checked;
      product.dataset = addonInput.dataset;
      product.gif = addonInput.dataset?.gif || product.gif;
    }

    if (addonText) {
      product.addon_text = addonText.textContent;
    }

    return {
      ...product,
      ...localData,
      quantity: quantityValue
    };
  }

  getLocalProductData(productHandle) {
    const node = document.querySelector(`.product-card-modal-data[data-product-modal-handle="${productHandle}"]`);
    if (!node) return {};

    try {
      const parsed = JSON.parse(node.textContent);
      parsed.dietary = Array.isArray(parsed.dietary) ? parsed.dietary.filter(Boolean) : [];
      return parsed;
    } catch (error) {
      console.warn('Could not parse product modal data', error);
      return {};
    }
  }

  getNutritionStats(product) {
    const statsMap = new Map();
    const nutritionObject = this.parseNutritionObject(product.nutritionalObject);

    if (Array.isArray(nutritionObject?.main)) {
      nutritionObject.main.forEach((item) => {
        const label = this.normalizeStatLabel(item?.description || item?.label || '');
        const value = String(item?.title || item?.value || '').trim();
        if (!label || !value) return;
        statsMap.set(label, value);
      });
    }

    if (product.proteinValue) {
      statsMap.set('Protein', product.proteinValue);
    }

    if (product.calories) {
      statsMap.set('Calories', String(product.calories));
    }

    const priority = ['Protein', 'Calories', 'Carbs', 'Fat', 'Fibre'];
    const stats = [];

    priority.forEach((label) => {
      if (!statsMap.has(label)) return;
      stats.push({
        label: this.formatStatLabel(label),
        value: this.formatStatValue(label, statsMap.get(label))
      });
      statsMap.delete(label);
    });

    statsMap.forEach((value, label) => {
      if (stats.length >= 4) return;
      stats.push({
        label: this.formatStatLabel(label),
        value: this.formatStatValue(label, value)
      });
    });

    return stats.slice(0, 4);
  }

  getPills(product) {
    const pills = [];
    const dietaryMap = {
      'gluten-free': { label: 'Gluten-Free', type: 'gluten-free' },
      'dairy-free': { label: 'Dairy-Free', type: 'dairy-free' },
      'vegan': { label: 'Vegan', type: 'vegan' }
    };

    (product.dietary || []).forEach((item) => {
      const pill = dietaryMap[item];
      if (pill) pills.push(pill);
    });

    if (product.freshnessText) {
      pills.push({
        label: String(product.freshnessText).replace(/\b([a-z])/g, (match) => match.toUpperCase()),
        type: 'freshness'
      });
    }

    return pills;
  }

  parseNutritionObject(rawValue) {
    if (!rawValue) return null;
    if (typeof rawValue === 'object') return rawValue;

    try {
      return JSON.parse(rawValue);
    } catch (_error) {
      return null;
    }
  }

  normalizeStatLabel(label) {
    const normalized = String(label).toLowerCase();
    if (normalized.includes('protein')) return 'Protein';
    if (normalized.includes('calor')) return 'Calories';
    if (normalized.includes('carb')) return 'Carbs';
    if (normalized.includes('fat')) return 'Fat';
    if (normalized.includes('fibre') || normalized.includes('fiber')) return 'Fibre';
    return normalized ? this.toTitleCase(normalized) : '';
  }

  formatStatLabel(label) {
    if (label === 'Fibre' && this.isUSMenu()) return 'Fiber';
    return label;
  }

  formatStatValue(label, value) {
    const trimmed = String(value).trim();
    if (!trimmed) return trimmed;

    if (label === 'Protein' || label === 'Carbs' || label === 'Fat' || label === 'Fibre') {
      return /\d$/.test(trimmed) ? `${trimmed}g` : trimmed;
    }

    return trimmed;
  }

  isUSMenu() {
    const host = window.location.hostname.toLowerCase();
    const path = window.location.pathname.toLowerCase();
    return host.endsWith('.com') || path.includes('usa');
  }

  formatSubtitle(rawValue) {
    let value = String(rawValue || '').trim();
    if (!value) return '';

    value = value.replace(/^with\s+/i, '').trim();

    if (/dressing/i.test(value)) {
      return `with ${value}`;
    }

    return `with ${value} dressing`;
  }

  formatMoney(cents) {
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  toTitleCase(value) {
    return value.replace(/\b\w/g, (match) => match.toUpperCase());
  }
}

const templateProductPopup = document.getElementById('productPopupTemplate');
const productPopupNode = templateProductPopup.content.querySelector('.product-popup');
const productNodePopup = document.body.appendChild(productPopupNode);

const productPopup = new ProductPopup(productNodePopup);
